/**
 * "Accessibility & RTL" — Widget section (ADR-0074).
 * Reconciled from the widget a11y posture (WCAG 2.1 AA) + RTL handling.
 */
import type { DocPageContent } from '../types';

export const WIDGET_A11Y_PAGE: DocPageContent = {
  slug: 'widget/accessibility',
  titleKey: 'docs.widget.a11y.title',
  descriptionKey: 'docs.widget.a11y.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.widget.a11y.lead' },

    { kind: 'heading', level: 2, id: 'wcag', textKey: 'docs.widget.a11y.wcag.heading' },
    {
      kind: 'list',
      itemKeys: [
        'docs.widget.a11y.wcag.item.keyboard',
        'docs.widget.a11y.wcag.item.focus',
        'docs.widget.a11y.wcag.item.contrast',
        'docs.widget.a11y.wcag.item.targets',
      ],
    },

    { kind: 'heading', level: 2, id: 'rtl', textKey: 'docs.widget.a11y.rtl.heading' },
    { kind: 'paragraph', textKey: 'docs.widget.a11y.rtl.body' },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.widget.a11y.next.languages.title',
          textKey: 'docs.widget.a11y.next.languages.text',
          to: { docSlug: 'languages' },
        },
        {
          titleKey: 'docs.widget.a11y.next.chat.title',
          textKey: 'docs.widget.a11y.next.chat.text',
          to: { docSlug: 'widget/chat' },
        },
      ],
    },
  ],
};
